<template>
  <!-- SECTION Alarms -->
  <div id="AlarmsSection" class="row col-12 m-0 p-0">
    <div class="row col-12 p-2 m-0 section-container">
      <div class="col-lg-12 col-md-12 col-12 m-0 overflow-hidden justify-content-center bg-white rounded-5 p-0">
        <div class="row col-lg-12 col-md-12 col-12 m-0 p-0 pb-3">
          <div class="position-sticky col-12 m-0 p-1 ps-2 pe-2 bg-head text-white border-1">
            <div class="row p-0 m-0">
              <div class="row col-xl-7 col-lg-8 col-md-12 col-12 m-0 p-0 ps-3 text-white rounded-5 rounded-end">
                <div v-if="displayActiveAlarms" class="col m-0 p-0 text-white d-flex" style="max-width: 290px;">
                  <h6 class="tx-left tx-14 text-white m-0 p-0 pe-4 mt-1 pt-1 d-flex flex-row">
                    <ion-icon name="warning-outline" class="tx-18 me-2 align-bottom"></ion-icon>
                    {{ dictionary["Alarmas"][session.user.language] }}
                  </h6>
                  <select v-if="this.$route.params.currentDisplay === 'alarms'" :value="currentCompany.nifCif"
                    class="form-control m-0 p-0 text-nowrap bg-white border"
                    style="border: solid 2px white ; color: black; width:180px; height: 34px;"
                    @change="onCurrentCompanyChanged">
                    <option class="text-uppercase p-4 bg-clomos tx-bold text-white"
                      v-if="availableCompanies[0] != undefined && availableCompanies.length > 1" value="showAll">
                      {{ dictionary['Mostrar todo'][session.user.language] }} </option>
                    <option class="text-capitalize" v-for="company in availableCompanies" :key="company.nifCif"
                      :v-if="company.nifCif != session.user.nifCif
                        && company.relation != undefined && company.relation.referenceCompany === this.session.user.nifCif" :value="company.nifCif">
                      {{ (company.nifCif === session.user.nifCif) ? "✪ " + company.name : company.name }}
                    </option>
                  </select>
                </div>
                <div v-show="displayActiveAlarms" class="col m-0 pt-0 ps-0 text-white">
                  <select v-if="this.$route.params.currentDisplay === 'alarms'" v-model="selectedAsset"
                    class="form-control m-0 p-0 text-nowrap bg-white border"
                    style="border: solid 2px white ; color: black; width:180px; height: 34px;"
                    @change="onAssetSelected">
                    <option value="" class="text-uppercase p-4 bg-clomos tx-bold text-white" disabled>
                      {{ dictionary["Seleccione un activo"][session.user.language] }}
                    </option>
                    <option class="text-capitalize p-1" v-for="asset in assetsList" :key="asset.id">
                      {{ asset.label }}
                    </option>
                  </select>
                </div>
                <div class="text-center p-1 pb-2 mt-0 rounded-5 border bg-danger shadow"
                  style="height: 34px; width: 200px;">
                  <span class="col kpi-title tx-14 text-end tx-bold text-white m-0 p-0 mt-2 me-2">Alarmas activas:
                  </span>
                  <span
                    class="col kpi-value tx-16 tx-bold mb-0 text-danger bg-white ps-1 text-center border border-white rounded">
                    {{
                      (activeAlarmsList.length > 0 ? activeAlarmsList.length : "0") + "/" + (alarmsList.length > 0
                        ? alarmsList.length : "0")
                    }}
                  </span>
                </div>
              </div>
              <!-- Fin Primera sección-->

              <div class="row col justify-content-end m-0 p-0">
                <span @click="toggleActiveAlarms"
                  class="col tx-14 text-center text-white pt-1 border-1 border-white me-3 c-pointer"
                  :style="displayActiveAlarms ? 'opacity=1;' : 'opacity: 0.7'"
                  style="max-width: 130px;height: 34px;">Alarmas activas</span>
                <span @click="toggleAllAlarms"
                  class="col tx-14 text-center text-white pt-1 border-1 border-white me-3 c-pointer"
                  :style="displayAllAlarms ? 'opacity=1;' : 'opacity: 0.7'" style="max-width: 134px;height: 34px;">Todas
                  las alarmas</span>
              </div>
            </div>
          </div>

          <!--Bloque Activas-->
          <div v-show="displayActiveAlarms"
            class="col-12 table-responsive bg-caja rounded-top-5 m-0 p-0 mb-3 overflow-hidden">
            <!-- KPI Row -->
            <div class="row p-0 m-0 justify-content-center">
              <div class="col-lg-5 col-md-12 p-3 pt-1">
                <div id="tableContent"
                  class="col-12 table-responsive bg-caja m-0 p-3 mt-3 mb-1 ms-2 rounded-5 shadow overflow-hidden w-100 borders-etiquetas">
                  <table id="ActiveAlarmsDataTable" class="col-12 m-0 p-0 dataTables_wrapper no-footer w-100">
                    <thead class="gradient-tablas tx-14 text-white text-center"
                      style="position: -webkit-sticky; position: sticky; top: 0; background-color: #343a40; z-index: 1;">
                      <tr>
                        <th v-for="column in activeAlarmColumns" :key="column.data" :width="column.width"
                          class="fw-medium text-nowrap p-1">
                          {{ dictionary[column.text][session.user.language] }}
                        </th>
                      </tr>
                    </thead>
                  </table>
                </div>
                <div class="col-12 bg-caja m-0 p-3 mt-3 mb-1 ms-2 rounded-5 shadow borders-etiquetas">
                  <p
                    class="text-start tx-16 tx-bold ps-3 pe-3 mb-2 m-0 p-0 w-100 rounded-top text-decoration-underline">
                    {{ dictionary["Evolucion"][session.user.language] + ": " + (
                      targetActiveAlarm.label ? targetActiveAlarm.label : "") }}</p>
                  <VueEcharts :option="historicActiveAlarmlineChartOptions" id="Chart1Canvas" class=""
                    style="height: 300px;"></VueEcharts>
                </div>
              </div>

              <div class="col-lg-7 col-md-12 mt-1 pe-4">
                <!-- Resumen de la alarma -->
                <div class="col-12 mt-1 pt-0 m-0 p-0">
                  <div class="col-lg-12 col-md-12 col-12 bg-caja m-0 p-3 mt-3 mb-1 ms-2 rounded-5 shadow borders-etiquetas"
                    style=" min-height: 604px;">
                    <span class="tx-18 tx-bold">{{ dictionary["Alarma"][session.user.language] + ' ' +
                      targetActiveAlarm.label != undefined ? targetActiveAlarm.label : '-' }}</span>
                    <div class="col-12 mb-0 mt-3">
                      <table class="table table-bordered table-striped text-start w-100">
                        <tbody>
                          <tr class="p-2" style="display: table-row;">
                            <th class="p-2 ps-3" style="width: 25% !important;" scope="row">
                              {{ dictionary["FechaActivacion"][session.user.language] }}</th>
                            <td class="p-2" v-if="targetActiveAlarm.statusDate">
                              {{ formatDateTime(targetActiveAlarm.statusDate) }} </td>
                          </tr>
                          <tr>
                            <th class="p-2 ps-3" style="width: 25% !important;" scope="row">{{ dictionary["Tipo incidencia"][session.user.language]}}</th>
                            <td class="p-2"> {{
                              targetActiveAlarm.incidenceType && targetActiveAlarm.incidenceType != '0' ?
                                targetActiveAlarm.incidenceType : '-'
                            }}</td>
                          </tr>
                          <tr>
                            <th class="p-2 ps-3" scope="row">{{ dictionary["IDIncidenciaAbierta"][session.user.language]
                              }}
                            </th>
                            <td class="p-2">
                              <span @click="toggleHistoricIncidenceModal(targetActiveAlarm.incidence)">{{
                                targetActiveAlarm.incidence ? targetActiveAlarm.incidence : '-' }}
                                <ion-icon v-if="targetActiveAlarm.incidence" name="link-outline"
                                  class="tx-20 ms-4 me-2 ps-1 pe-1 border border-danger align-top text-danger tx-bold md hydrated"></ion-icon>
                              </span>
                              <span
                                class="tx-12 ms-2 me-2 pb-1 ps-2 pe-2 border border-dark align-top text-dark tx-bold md hydrated"
                                v-if="targetActiveAlarm.historicIncidences && targetActiveAlarm.historicIncidences.length > 0"
                                @click="displayhistoricIncidences = !displayhistoricIncidences">
                                {{ displayhistoricIncidences ? 'ver menos' : 'ver más' }}
                              </span>
                            </td>
                          </tr>
                          <template v-if="displayhistoricIncidences">
                            <tr>
                              <td colspan="2">
                                <strong>{{ dictionary["IncidenciasAbiertasUltimas48Horas"][session.user.language]
                                  }}</strong>
                              </td>
                            </tr>
                            <tr>
                              <th>{{ dictionary["Fecha"][session.user.language] }}</th>
                              <th>{{ dictionary["NumeroIncidencia"][session.user.language] }}</th>
                            </tr>
                            <tr v-for="(item, index) in targetActiveAlarm.historicIncidences" :key="index">
                              <td>
                                {{ formatDateTime(item[0]) }}
                              </td>
                              <td @click="toggleHistoricIncidenceModal(item[1])" style="cursor: pointer;">
                                {{ item[1] }}
                              </td>
                            </tr>
                          </template>
                        </tbody>
                      </table>
                    </div>
                    <div class="col-12 mb-3 mt-3">
                      <span class="text-center tx-bold tx-14 mb-2">
                        {{ (targetActiveAlarm.variableLabel ?
                          targetActiveAlarm.variableLabel : "") + " : " + (targetActiveAlarm.valueNow ?
                            targetActiveAlarm.valueNow
                            : '-') }}
                      </span>
                      <VueEcharts :option="activeAlarmLineChartOptions" id="Chart2Canvas" class="border-top"
                        style="height: 336px;">
                      </VueEcharts>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--Fin Bloque Activas-->
        </div>
      </div>

      <!-- Main content -->

      <div v-show="displayAllAlarms" class="col-lg-12 col-md-12 col-12 m-0 p-0 pt-3">
        <!-- BLOQUE SEGUNDO -->
        <div class="col-12 table-responsive bg-caja rounded-top-5 m-0 p-0 shadow overflow-hidden">
          <div class="row position-sticky col-12 m-0 p-1 bg-head text-white border-1">
            <div class="row position-sticky col-lg-8 col-md-9 col-12 m-0 p-0 ps-3 pe-2 text-end text-white">
              <div class="col m-0 pt-0 ps-0 text-white d-flex flex-row" style="max-width: 310px;">
                <h6 class="tx-left tx-14 text-white m-0 p-0 pe-4 mt-1 pt-1 d-flex flex-row">
                  <ion-icon name="warning-outline" class="tx-18 me-2 align-bottom"></ion-icon>
                  {{ dictionary["Alarmas"][session.user.language] }}
                </h6>
                <select v-if="this.$route.params.currentDisplay === 'alarms'" :value="currentCompany.nifCif"
                  class="form-control m-0 p-0 text-nowrap bg-white border"
                  style="border: solid 2px white ; color: black; width:200px; height: 34px;"
                  @change="onCurrentCompanyChanged">
                  <option class="text-uppercase p-4 bg-clomos tx-bold text-white"
                    v-if="availableCompanies[0] != undefined && availableCompanies.length > 1" value="showAll">
                    {{ dictionary['Mostrar todo'][session.user.language] }} </option>
                  <option class="text-capitalize" v-for="company in availableCompanies" :key="company.nifCif" :v-if="company.nifCif != session.user.nifCif
                    && company.relation != undefined && company.relation.referenceCompany === this.session.user.nifCif"
                    :value="company.nifCif">
                    {{ (company.nifCif === session.user.nifCif) ? "✪ " + company.name : company.name }}
                  </option>
                </select>
              </div>

              <div class="col m-0 pt-0 ps-0 text-white">
                <select v-if="this.$route.params.currentDisplay === 'alarms'" v-model="selectedAsset"
                  class="form-control m-0 p-0 text-nowrap bg-white border"
                  style="border: solid 2px white ; color: black; width:200px; height: 34px;" @change="onAssetSelected">
                  <option value="" class="text-uppercase p-4 bg-clomos tx-bold text-white" disabled>
                    {{ dictionary["Seleccione un activo"][session.user.language] }}
                  </option>
                  <option class="text-capitalize p-1" v-for="asset in assetsList" :key="asset.id">
                    {{ asset.label }}
                  </option>
                </select>
              </div>
            </div>
            <div class="position-sticky col m-0 p-0 text-end text-white">
              <button class="col rounded-5 bg-success border border-white p-1" style="max-width:240px;">
                <span @click="toggleNewCondition">
                  <ion-icon name="push" class="text-white pt-0 me-2 tx-20 align-bottom hydrated"></ion-icon>
                  Nueva Condición</span>
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-5 col-md-12 mt-0 p-2 ps-4">
              <div class="table-responsive p-3 rounded-5 shadow borders-etiquetas "
                style=" min-height: 204px;">
                <table id="AlarmsDataTable" class="table table-striped p-0 pb-3 bg-caja w-100">
                  <thead class="gradient-tablas tx-14 text-white text-center"
                    style="position: sticky; top: 0; background-color: #343a40; z-index: 1;">
                    <tr>
                      <th v-for="column in alarmColumns" :key="column.data" :width="column.width"
                        class="fw-medium text-nowrap p-2">
                        {{ dictionary[column.text][session.user.language] }}
                      </th>
                    </tr>
                  </thead>
                </table>
              </div>
              <div class="col-12 mb-3 mt-3 rounded-5 shadow borders-etiquetas">
                <p
                  class="text-start tx-16 tx-bold ps-3 pe-3 pt-2 mb-2 m-0 p-0 w-100 rounded-top text-decoration-underline">
                  {{
                    dictionary["Evolucion"][session.user.language] + ": " + (
                      targetAlarm.label ? targetAlarm.label : "") }}
                </p>
                <VueEcharts :option="historicalarmlineChartOptions" id="Chart2Canvas" class="mt-3"
                  style="height: 270px;">
                </VueEcharts>
              </div>
            </div>
            <div class="col-lg-7 col-md-12 mt-0 pt-0">
              <div class="col-12 mt-2 mb-3">
                <div class=" rounded pb-0 pt-2 rounded-5 shadow borders-etiquetas">
                  <span class="tx-18 tx-bold"> {{ dictionary["AlarmaSeleccionada"][session.user.language] + ':' +
                    targetAlarm.label
                    }}</span>
                  <div class="row p-3">
                    <div class="col-md-12 " :class="firefox ? 'col-lg-2' : 'col-lg-4'">
                      <input type="datetime-local" v-model="targetAlarm.startDateTime"
                        class=" form-control border p-2 rounded-2 text-nowrap bg-white"
                        style="border: solid 1px white ; color: black;" :disabled="!targetAlarm">
                    </div>
                    <div v-if="firefox" class="col-lg-2 col-md-12 ">
                      <input type="time" v-model="targetAlarm.startTime"
                        class=" form-control border p-2 pt-3 pb-3 rounded-2 text-nowrap bg-white"
                        style="border: solid 1px white ; color: black;" :disabled="!targetAlarm">
                    </div>
                    <div class="col-md-12 " :class="firefox ? 'col-lg-2' : 'col-lg-4'">
                      <input type="datetime-local" v-model="targetAlarm.endDateTime"
                        class=" form-control  border rounded-2 p-2 text-nowrap bg-white"
                        style="border: solid 2px white ; color: black;" :disabled="!targetAlarm">
                    </div>
                    <div v-if="firefox" class="col-lg-2 col-md-12">
                      <input type="time" v-model="targetAlarm.endTime"
                        class=" form-control border p-2 rounded-2 text-nowrap bg-white"
                        style="border: solid 1px white ; color: black;" :disabled="!targetAlarm">
                    </div>
                    <div class="col-lg-4 col-md-12 m-0 p-0">
                      <button id="btnDisplayNewMachineModal"
                        :disabled="!targetAlarm.startDateTime && !targetAlarm.endDateTime" type="button"
                        style="max-height: 38px;" class="button-ok gradient-tablas rounded-3"
                        @click="searchSelectedFilter">
                        <span class="button-text text-white">
                          <ion-icon name="search-circle-outline" class="text-white pt-0 me-2 tx-20 hydrated"></ion-icon>
                          <span class="text-white mt-0 text-nowrap">{{ dictionary["Buscar"][session.user.language]
                            }}</span>
                        </span>
                      </button>
                    </div>
                    <div class="col-12 mb-3 mt-3">
                      <span class="text-center tx-18 mb-2 text-decoration-underline">
                        {{ (targetAlarm.variableLabel ?
                          targetAlarm.variableLabel : "-") + ": " + (targetAlarm.valueNow ?
                            targetAlarm.valueNow :
                            '-') }}
                      </span>
                      <VueEcharts :option="alarmLineChartOptions" id="Chart2Canvas" class="" style="height: 452px;">
                      </VueEcharts>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
  <!-- MODAL Historic Modal -->
  <HistoricIncidenceModal v-if="displayHistoricIncidence" :session="session" :dictionary="dictionary"
    :countries="countries" :timeZones="timeZones" :currentCompany="currentCompany"
    :availableCompanies="availableCompanies" :incidenceId="incidenceNumber"
    v-on:toggleHistoricIncidenceModal="toggleHistoricIncidenceModal">

  </HistoricIncidenceModal>

  <!-- MODAL New Condition Modal -->

  <NewConditionModal v-if="displayNewCondition" :session="session" :dictionary="dictionary" :countries="countries"
    :timeZones="timeZones" :currentCompany="currentCompany" :availableCompanies="availableCompanies"
    :incidenceId="incidenceNumber" :dcl="dcl[0] ? dcl[0].id : ''" v-on:toggleCreateConditionModal="toggleNewCondition">

  </NewConditionModal>
  <!-- MODAL Edit conditon  -->

  <EditConditionModal v-if="displayEditCondition" :session="session" :dictionary="dictionary" :countries="countries"
    :timeZones="timeZones" :currentCompany="currentCompany" :availableCompanies="availableCompanies"
    :idCondition="targetConditionId" :condition="condition" :idDcl="dcl[0] ? dcl[0].id : ''" v-on:toggleEditCondition="toggleEditCondition">

  </EditConditionModal>

  <!-- MODAL Delete Text Alert -->
  <TextAlertModal v-if="displayDeleteCondition" :session="session" :dictionary="dictionary" :countries="countries"
    :alertHeader="dictionary['Condicion a eliminar'][session.user.language] + ': '" :alertTarget="targetConditionId"
    v-on:acceptAlert="onDeleteCondition" v-on:dismissAlert="toggleDeleteConditionModal">
  </TextAlertModal>

</template>

<script>
import { VueEcharts } from 'vue3-echarts';
// Clomos
import api from '@/services/api';
import $ from 'jquery';

import HistoricIncidenceModal from '@/components/incidences/HistoricIncidenceModal'
import NewConditionModal from '@/components/conditions/NewConditionModal'
import EditConditionModal from '@/components/conditions/EditConditionModal'
import TextAlertModal from '@/components/other/TextAlertModal';


export default {
  name: "AlarmsComponent",
  components: { VueEcharts, HistoricIncidenceModal, NewConditionModal, EditConditionModal, TextAlertModal },
  props: {
    session: {
      type: Object,
      required: true,
    },
    dictionary: {
      type: Object,
      required: true,
    },
    countries: {
      type: Object,
      required: true,
    },
    timeZones: {
      type: Object,
      required: true,
    },
    visibility: {
      type: Object,
      required: true,
    },
    currentCompany: {
      type: Object,
      required: true,
    },
    availableCompanies: {
      type: Object,
      required: true,
    },
    targetEmplacementId: {
      type: String,
      required: true,
    },
    dataTableOptions: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      dcl: '',
      alarmColumns: [
        {
          text: "Seleccione Alarma", data: "alarmId", width: "5%", className: "align-middle",
          render: (data) => {
            return "<input type='radio' name='select-alarmFromList' value='" + data + "' class='radio-select-alarm btnDetailAlarmFromList'>";
          }
        },
        {
          text: "Alarma", data: "alarmName", width: "10%", className: "tx-left align-middle",
          render: (data) => {
            return data;
          }
        },
        {
          text: "Estado", data: "alarmStatus", width: "10%", className: "tx-left align-middle",
          render: (data) => {
            let text;
            switch (data) {
              case "0":
                text = this.dictionary["Desactivado"][this.session.user.language];
                break;
              case "1":
                text = ("pre" + this.dictionary["Activado"][this.session.user.language].toLowerCase());
                break;
              case "2":
                text = this.dictionary["Activado"][this.session.user.language];
                break;
              case "3":
                text = ("post" + this.dictionary["Activado"][this.session.user.language].toLowerCase());
                break;
              default:
                text = data.status;
            }
            return text
          }
        },
        {
          text: "Configuración", data: "alarmId", width: "5%", className: "align-middle",
          render: (data) => {
            return "<ion-icon name='settings-outline' data-id=" + data + " class='btnEditCondition btn tx-18 tx-primary'></ion-icon>"
          }
        },
        {
          text: "Eliminar", data: "alarmId", width: "5%", className: "align-middle",
          render: (data) => {
            return "<ion-icon name='trash-outline' data-id=" + data + " class='btnDeleteCondition btn tx-18 tx-danger'></ion-icon>"
          }
        },

      ],
      activeAlarmColumns: [
        {
          text: "Seleccione Alarma", data: "activeAlarmId", width: "20%", className: "align-middle",
          render: (data) => {
            return "<input type='radio' name='select-alarm' value='" + data + "' class='radio-select-alarm btnDetailAlarm p-0'>";
          }
        },
        {
          text: "Alarma", data: "activeAlarmName", width: "40%", className: "tx-left align-middle p-0",
          render: (data) => {
            return data;
          }
        },
        {
          text: "Fecha Activacion", data: "activationDate", width: "27%", className: "tx-left align-middle p-0",
          render: (data) => {

            return (api.parseDateUserTimezone(data, this.session.user, this.$dayjs))
          }
        },
        {
          text: "Silenciar Alarma",
          data: "activeAlarmSilenced",
          width: "5%",
          className: "align-middle",
          render: (data) => {
            const iconName = data.isMuted === "true" ? 'volume-high-outline' : 'volume-mute-outline';

            return (
              `<ion-icon name="${iconName}" data-id="${data.id}" class="btnChangeIsMuted btn tx-18 text-black m-0 p-0"></ion-icon>`
            );
          }
        },

      ],
      incidenceNumber: null,
      incidenceList: {},
      targetActiveAlarmId: null,
      selectedAsset: "",
      selectedCompany: null,
      displayHistoricIncidence: false,
      displayNewCondition: false,
      displayEditCondition: false,
      displayDeleteCondition: false,
      displayActiveAlarms: false,
      displayAllAlarms: true,
      firefox: false,
      assetsList: {},
      alarmsList: {},
      incidence: {},
      activeAlarmsList: {},
      preActive: {},
      postActive: {},
      targetEmplacementData: {},
      targetActiveAlarm: "",
      targetConditionId: "",
      targetAlarm: "",
      alarmLineChartOptions: {
        toolbox: {
          feature: {
            dataView: {
              readOnly: true
            },
            dataZoom: {
              show: true,
              yAxisIndex: null
            },
            magicType: {
              type: ['line', 'bar']
            },
            saveAsImage: {
              pixelRatio: 2
            }
          }
        }
      },
      historicalarmlineChartOptions: {
        toolbox: {
          feature: {
            dataView: {
              readOnly: true
            },
            dataZoom: {
              show: true,
              yAxisIndex: null
            },
            magicType: {
              type: ['line', 'bar']
            },
            saveAsImage: {
              pixelRatio: 2
            }
          }
        }
      },
      activeAlarmLineChartOptions: {
        toolbox: {
          feature: {
            dataView: {
              readOnly: true
            },
            dataZoom: {
              show: true,
              yAxisIndex: null
            },
            magicType: {
              type: ['line', 'bar']
            },
            saveAsImage: {
              pixelRatio: 2
            }
          }
        }
      },
      historicActiveAlarmlineChartOptions: {
        toolbox: {
          feature: {
            /*dataView: {
                readOnly: true 
            },
            dataZoom: {
                show: true,
                yAxisIndex: null
            },
            magicType: {
                type: ['line', 'bar'] 
            },
            saveAsImage: {
                pixelRatio: 2 
            }*/
          }
        }
      },
      displayhistoricIncidences: false,
      condition:""
    }
  },
  
  computed: {
    fractionalLength() {
      return (localStorage.getItem("ClomosFractionalLength") != undefined) ? localStorage.getItem("ClomosFractionalLength") : 2;
    },
  },
  watch: {

    'targetAlarm.startTime': {
      handler(newTime) {
        if (newTime) {
          let currentStartDate = this.targetAlarm.startDateTime || new Date().toISOString();
          currentStartDate = new Date(currentStartDate);
          const datePart = currentStartDate.toISOString().split('T')[0];
          this.targetAlarm.startDateTime = `${datePart}T${newTime}`;

        }
      },
      deep: true,
    },


    'targetAlarm.startDateTime': {
      handler(newDateTime) {
        if (newDateTime) {
          const dateObject = new Date(newDateTime);
          const timePart = dateObject.toTimeString().split(' ')[0];
          this.targetAlarm.startTime = timePart;
        }
      },
      deep: true,
    },
    'targetAlarm.endDateTime': {
      handler(newDateTime) {
        if (newDateTime) {
          const dateObject = new Date(newDateTime);
          const timePart = dateObject.toTimeString().split(' ')[0];
          this.targetAlarm.endTime = timePart;

        }
      },
      deep: true,
    },
    'targetAlarm.endTime': {
      handler(newTime) {
        if (newTime) {
          let currentEndDate = this.targetAlarm.endDateTime || new Date().toISOString();
          currentEndDate = new Date(currentEndDate);

          const datePart = currentEndDate.toISOString().split('T')[0];
          this.targetAlarm.endDateTime = `${datePart}T${newTime}`;

        }
      },
      deep: true,
    }
  },
  emits: ["setCurrentCompany", "getAvailableCompanies"],
  methods: {
    async exportCSVWithDialog(dataTable) {
      try {
        const exportData = typeof dataTable?.buttons?.exportData === 'function'
          ? dataTable.buttons.exportData({
              columns: ':visible',
              modifier: {
                search: 'applied',
                order: 'applied'
              }
            })
          : null;
        const headers = Array.isArray(exportData?.header) ? exportData.header : [];
        const rows = Array.isArray(exportData?.body) ? exportData.body : [];
        const csvContent = this.generateCSVContent(rows, headers);
        const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-');
        const fileName = `${this.currentCompany?.name || 'export'}_data_${timestamp}.csv`;

        if ('showSaveFilePicker' in window && window.isSecureContext) {
          try {
            const fileData = "﻿" + csvContent;
            const fileHandle = await window.showSaveFilePicker({
              suggestedName: fileName,
              types: [{
                description: 'CSV File',
                accept: { 'text/csv': ['.csv'] }
              }]
            });
            const writable = await fileHandle.createWritable();
            await writable.write(fileData);
            await writable.close();
            return;
          } catch (error) {
            if (error.name !== 'AbortError') {
              console.error('Error con showSaveFilePicker:', error);
            }
            if (error.name === 'AbortError') return;
          }
        }

        this.fallbackDownloadCSV(csvContent, fileName);
      } catch (error) {
        console.error('Error exportando CSV:', error);
      }
    },
    generateCSVContent(data, columns) {
      const separator = this.session?.user?.fieldSeparator || ';';
      const headers = (columns || []).map((column) => this.escapeCSVField(this.getCSVHeaderLabel(column)));
      let csvContent = headers.join(separator) + '\n';

      for (let i = 0; i < data.length; i++) {
        const row = Array.isArray(data[i]) ? data[i] : [data[i]];
        const rowData = row.map((field) => this.escapeCSVField(this.extractValueFromRow(field)));
        csvContent += rowData.join(separator) + '\n';
      }

      return csvContent;
    },
    getCSVHeaderLabel(column) {
      const headerText = (column === null || column === undefined ? '' : String(column)).replace(/\s+/g, ' ').trim();
      return this.dictionary?.[headerText]?.[this.session?.user?.language] || headerText;
    },
    extractValueFromRow(field) {
      if (field === null || field === undefined) return '';
      if (typeof field === 'string') {
        const container = document.createElement('div');
        container.innerHTML = field;
        return (container.textContent || container.innerText || '').replace(/\s+/g, ' ').trim();
      }
      if (typeof field === 'number' || typeof field === 'boolean') return String(field);
      if (Array.isArray(field)) return field.map((item) => this.extractValueFromRow(item)).join(', ');
      if (typeof field === 'object') return JSON.stringify(field);
      return String(field);
    },
    escapeCSVField(field) {
      const normalizedField = field === null || field === undefined ? '' : String(field);
      if (
        normalizedField.includes('"') ||
        normalizedField.includes(';') ||
        normalizedField.includes(',') ||
        normalizedField.includes('\n') ||
        normalizedField.includes('\r')
      ) {
        return `"${normalizedField.replace(/"/g, '""')}"`;
      }
      return normalizedField;
    },
    fallbackDownloadCSV(csvContent, fileName) {
      const blob = new Blob(["\uFEFF" + csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute("download", fileName);
      link.style.display = "none";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },

    //DISPLAY
    async toggleDeleteConditionModal() {
      this.displayDeleteCondition = !this.displayDeleteCondition
      if (this.dcl && this.dcl[0].id && !this.displayDeleteCondition) {
        await this.getAlarmsbyDcl(this.dcl)
        this.displayActiveAlarmsDataTable()
        this.displayAlarmsDataTable()
      }
    },
    async toggleNewCondition() {
      this.displayNewCondition = !this.displayNewCondition
      if (this.dcl && this.dcl[0].id && !this.displayNewCondition) {
        await this.getAlarmsbyDcl(this.dcl)
        this.displayActiveAlarmsDataTable()
        this.displayAlarmsDataTable()
      }

    },
    async toggleEditCondition() {
      this.displayEditCondition = !this.displayEditCondition
      if (!this.displayEditCondition) {
        await this.getAlarmsbyDcl(this.dcl)
        this.displayActiveAlarmsDataTable()
        this.displayAlarmsDataTable()
      }

    },
    toggleHistoricIncidenceModal(idIncidence) {
      this.incidenceNumber = idIncidence
      this.displayHistoricIncidence = !this.displayHistoricIncidence;
    },
    toggleActiveAlarms() {
      if (!this.displayActiveAlarms) {
        this.$nextTick(() => {
          this.clearTables()
          this.displayActiveAlarmsDataTable()
        });
      }


      this.displayActiveAlarms = !this.displayActiveAlarms;
    },
    toggleAllAlarms() {
      if (this.displayAllAlarms) {

        this.$nextTick(() => {
          this.clearTables()
          this.displayAlarmsDataTable()
        });
      }
      this.displayAllAlarms = !this.displayAllAlarms;
    },
    async displayVariablesChartOptions(displayData) {
  let variableHistoricData = [];

  try {
    let response = await api.getMachineVariableHistory(displayData);
    if (response["status-code"] === "500") {
      response=   await api.getBundleVariableHistory(displayData);     
      if (response["status-code"] === "500") {      
        response=   await api.getDeviceVariableHistory(displayData);               
      }
    } 
    if (response["status-code"] === "200") {
      variableHistoricData = api.parseVariableDataFromHistoryResponse(response);
      const value = parseFloat(variableHistoricData.value).toFixed(this.fractionalLength);
      const unit = variableHistoricData.unit;
      const resultado = `${value} ${unit}`;

      if (displayData.active) {
        this.targetActiveAlarm.valueNow = resultado;
      } else {
        this.targetAlarm.valueNow = resultado;
      }
    } else {
      
      return this.getEmptyChartOptions();
    }
  } catch (error) {
    console.error("Error fetching variable history:", error);
    return this.getEmptyChartOptions();
  }

  const dates = variableHistoricData.history.map(item => item[0]);
  const statusDateTimestamp = new Date(displayData.statusDate).getTime();

  if (variableHistoricData.type === "1") {
    return this.getLineChartOptions(dates, variableHistoricData, displayData, statusDateTimestamp);
  } else if (variableHistoricData.type === "0") {
    return this.getDigitalChartOptions(dates, variableHistoricData, displayData, statusDateTimestamp);
  }

  return this.getEmptyChartOptions();
},

getEmptyChartOptions() {
  return {
    xAxis: {
      type: 'time',
      data: []
    },
    yAxis: {
      type: 'value'
    },
    series: [{
      type: 'line',
      data: []
    }]
  };
},

getLineChartOptions(dates, variableHistoricData, displayData, statusDateTimestamp) {
  const dataValues = variableHistoricData.history.map(item => item[1]);
  const lowerLimit = displayData.hasLowerLimit === "true" ? parseInt(displayData.lowerLimit) : null;
  const upperLimit = displayData.hasUpperLimit === "true" ? parseInt(displayData.upperLimit) : null;
  const margin = 10;
  const minValue = Math.floor(Math.min(...dataValues, lowerLimit !== null ? lowerLimit : Infinity) - margin);
  const maxValue = Math.ceil(Math.max(...dataValues, upperLimit !== null ? upperLimit : -Infinity) + margin);

  return {
    toolbox: {
      feature: {
        dataView: { readOnly: true },
        dataZoom: { show: true, yAxisIndex: null },
        magicType: { type: ['line', 'bar'] },
        saveAsImage: { pixelRatio: 2 }
      }
    },
    tooltip: { trigger: 'axis' },
    xAxis: {
      type: 'time',
      data: dates.map(date => new Date(date).getTime()),
      axisLabel: {
        formatter: value => {
          const date = new Date(value);
          return `${String(date.getDate()).padStart(2, "0")}/${String(date.getMonth() + 1).padStart(2, "0")}/${date.getFullYear()} \n ${String(date.getHours()).padStart(2, "0")}:${String(date.getMinutes()).padStart(2, "0")}`;
        },
        margin: 10,
        fontSize: 10,
      },
      axisTick: { alignWithLabel: true }
    },
    yAxis: {
      type: 'value',
      min: minValue,
      max: maxValue,
      axisLabel: {
        formatter: (value) => {
          return new Intl.NumberFormat(
            this.session.user.language === "en" ? "en-IN" : "es-ES",
            { maximumFractionDigits: Number(this.fractionalLength) }
          ).format(value) + (variableHistoricData?.unit ? ` ${variableHistoricData.unit}` : '');
        }
      }
    },
    grid: { top: '10%', left: '16%', right: '16%' },
    series: [{
      name: displayData.variableLabel,
      type: 'line',
      data: dataValues.map((value, index) => [new Date(dates[index]).getTime(), value]),
      symbol: 'none',
      markLine: {
        data: [
          ...(displayData.hasUpperLimit === "true" ? [{
            yAxis: parseInt(displayData.upperLimit),
            name: 'Límite superior',
            lineStyle: { type: 'dashed', color: 'red', width: 2 }
          }] : []),
          ...(displayData.hasLowerLimit === "true" ? [{
            yAxis: parseInt(displayData.lowerLimit),
            name: 'Límite inferior',
            lineStyle: { type: 'dashed', color: 'red', width: 2 }
          }] : []),
          {
            xAxis: statusDateTimestamp,
            name: 'Alarma',
            lineStyle: { type: 'solid', color: 'red', width: 2 }
          }
        ],
        symbol: 'none',
        label: { formatter: params => params.name }
      }
    }]
  };
},

getDigitalChartOptions(dates, variableHistoricData, displayData, statusDateTimestamp) {
  const dataValuesDigital = variableHistoricData.history.map(item => item[1] === "true" ? 1 : 0);

  return {
    toolbox: {
      feature: {
        dataView: { readOnly: true },
        dataZoom: { show: true, yAxisIndex: null },
        magicType: { type: ['line', 'bar'] },
        saveAsImage: { pixelRatio: 2 }
      }
    },
    tooltip: { trigger: 'axis' },
    xAxis: {
      type: 'time',
      boundaryGap: false,
      data: dates.map(date => new Date(date).getTime()),
      axisLabel: {
        formatter: value => {
          const date = new Date(value);
          return `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}/n ${date.getHours()}:${date.getMinutes()}`;
        }
      }
    },
    yAxis: {
      type: 'value',
      min: 0,
      max: 1,
      axisLabel: {
        formatter: (value) => {
          return new Intl.NumberFormat(
            this.session.user.language === "en" ? "en-IN" : "es-ES",
            { maximumFractionDigits: Number(this.fractionalLength) }
          ).format(value) + (variableHistoricData?.unit ? ` ${variableHistoricData.unit}` : '');
        }
      }
    },
    series: [{
      name: displayData.variableLabel,
      type: 'line',
      data: dataValuesDigital.map((value, index) => [new Date(dates[index]).getTime(), value]),
      symbol: 'none',
      markLine: {
        data: [{
          xAxis: statusDateTimestamp,
          name: 'Alarma',
          lineStyle: { type: 'solid', color: 'red', width: 2 }
        }],
        symbol: 'none',
        label: { formatter: params => params.name }
      }
    }]
  };
},
    displayHistoricChartOptions(chartVariableDisplayData) {

      const stateMapping = {
        0: 'Desactivada',
        1: 'Preactivada',
        2: 'Activada',
        3: 'Postactivada',
      };


      const orderedStates = [0, 1, 3, 2];


      const dates = chartVariableDisplayData.history.map(item => {
        const date = new Date(item[0]);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${day}-${month}-${year} ${hours}:${minutes}`;
      });


      const dataValues = chartVariableDisplayData.history.map(item => Number(item[1]));


      const lineChartOptions = {

        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: dates,
          axisLabel: {
            rotate: 15,
            margin: 10,
            fontSize: 9
          },
          axisTick: {
            show: false
          }
        },
        yAxis: {
          type: 'category',
          data: orderedStates.map(state => stateMapping[state]),
          axisLabel: {
            formatter: value => value,
            margin: 10,
            fontSize: 12
          },
          axisTick: {
            show: false
          }
        },
        grid: {
          left: '16%',
          right: '3%',
          top: '1%',
          bottom: '19%'
        },
        series: [
          {
            name: 'Estado',
            type: 'line',
            data: dataValues.map((value, index) => [dates[index], stateMapping[value]]),
            smooth: false,
            step: 'start',
            itemStyle: {
              color: 'red'
            },
            lineStyle: {
              color: '#CCCCCC'
            }
          }
        ],
      };

      return lineChartOptions;
    },
    displayActiveAlarmsDataTable() {
      const table = $("#ActiveAlarmsDataTable").DataTable();

      table.clear();

      for (let i in this.activeAlarmsList) {
        table.rows.add([{
          activeAlarmId: this.activeAlarmsList[i].id,
          activeAlarmName: this.activeAlarmsList[i].label,
          activationDate: this.activeAlarmsList[i].statusDate,
          activeAlarmSilenced: {
            isMuted: this.activeAlarmsList[i].isMuted,
            id: this.activeAlarmsList[i].id
          }
        }]);
      }

      table.draw();
      this.setButtonFunctions();

      setTimeout(() => {
        const firstRadioBtn = $("#ActiveAlarmsDataTable input[type='radio']").first();
        if (firstRadioBtn.length) {
          const firstRadioValue = firstRadioBtn.val();
          firstRadioBtn.prop("checked", true).trigger('click');
          this.onDetailActiveAlarm(firstRadioValue);
        }
      }, 300);
      if ($("#ActiveAlarmsDataTable_paginate").get()[0] != undefined) {
        $("#ActiveAlarmsDataTable_paginate").get()[0].addEventListener("click", this.setButtonFunctions);
      }
      $(".sorting").get().forEach((btn) => { btn.addEventListener('click', this.setButtonFunctions) });
    },
    displayAlarmsDataTable() {
      $("#AlarmsDataTable").DataTable().clear()
      for (let i in this.alarmsList) {
        $("#AlarmsDataTable").DataTable().rows.add([{
          alarmId: this.alarmsList[i].id,
          alarmName: this.alarmsList[i].label,
          alarmStatus: this.alarmsList[i].status,
        }]);
      }


      $("#AlarmsDataTable").DataTable().draw();
      this.setButtonFunctions();
      setTimeout(() => {
        const firstRadioBtn = $("#AlarmsDataTable input[type='radio']").first();
        if (firstRadioBtn.length) {
          const firstRadioValue = firstRadioBtn.val();
          firstRadioBtn.prop("checked", true).trigger('click');
          this.onDetailAlarm(firstRadioValue);
          const now = new Date();
          this.targetAlarm.startDateTime = new Date(now.getTime() - 48 * 60 * 60 * 1000)
            .toISOString().replace('T', ' ').substr(0, 23);
          this.targetAlarm.endDateTime = now.toISOString().replace('T', ' ').substr(0, 23);
          this.searchSelectedFilter()
        }
      }, 300);
      if ($("#AlarmsDataTable_paginate").get()[0] != undefined) $("#AlarmsDataTable_paginate").get()[0].addEventListener("click", this.setButtonFunctions);
      $(".sorting").get().forEach((btn) => { btn.addEventListener('click', this.setButtonFunctions) });

    },

    onEditCondition(event) {
      this.targetConditionId = event.target.getAttribute('data-id');
      this.condition =this.alarmsList.filter(condition => condition.id===this.targetConditionId);      
      this.toggleEditCondition()

    },
    async onDeleteCondition(event) {
      if (!this.displayDeleteCondition) {
        this.targetConditionId = event.target.getAttribute('data-id');
      } else {
        let response = await api.deleteCondition(this.targetConditionId)
        if (response["status-code"] === "200") {
          window.alert(this.dictionary["La condicion ha sido eliminada satisfactoriamente."][this.session.user.language]);
        }
        else {
          window.alert(this.dictionary["Error al eliminar la condicion."][this.session.user.language]);
        }
      }
      await this.toggleDeleteConditionModal()




    },
    async onDetailActiveAlarm(activeAlarmId) {
      this.targetActiveAlarm = "";
      this.targetActiveAlarmId = activeAlarmId;
      this.targetActiveAlarm = this.activeAlarmsList.find((item) => item.id === this.targetActiveAlarmId);
      const startDataTimeHistorical = new Date(new Date(this.targetActiveAlarm.statusDate).setHours(new Date(this.targetActiveAlarm.statusDate).getHours() - 48)).toISOString().replace('T', ' ').substr(0, 23)
      const endDateTimeHistorical = new Date().toISOString().replace('T', ' ').substr(0, 23)
      const dataforHistorical = {
        id: this.targetActiveAlarm.id,
        startDataTimeHistorical: startDataTimeHistorical,
        endDateTimeHistorical: endDateTimeHistorical
      }
      const filteredIncidence = [...this.incidence].filter((item) => item.id === this.targetActiveAlarm.incidenceType);
      if (filteredIncidence.length > 0) {
        this.targetActiveAlarm.incidenceType = filteredIncidence[0].label
      }

      const getHistoricalofCondition = await this.getHistoricalofCondition(dataforHistorical)
      this.targetActiveAlarm.historicIncidences = getHistoricalofCondition
        .filter(item => item[2].length > 0 && item[2] !== this.targetActiveAlarm.incidence)
        .reduce((uniqueItems, item) => {
          if (!uniqueItems.some(existingItem => existingItem[1] === item[2])) {
            uniqueItems.push([item[0], item[2]]);
          }
          return uniqueItems;
        }, []);
      let idDCL = this.assetsList.filter((item) => item.label === this.selectedAsset);
      let chartVariableDisplayData = {
        active: true,
        variableLabel: this.targetActiveAlarm.variableLabel,
        variableType: this.targetActiveAlarm.type === "0" ? "1" : "0", //modificar cuando se añadan las condiciones dinamicas      
        status: this.targetActiveAlarm.status,
        statusDate: this.targetActiveAlarm.statusDate,
        id: idDCL[0].id,
        startDateTime: new Date(new Date(this.targetActiveAlarm.statusDate).setHours(new Date(this.targetActiveAlarm.statusDate).getHours() - 1)).toISOString().replace('T', ' ').substr(0, 23),
        endDateTime: new Date(new Date(this.targetActiveAlarm.statusDate).setHours(new Date(this.targetActiveAlarm.statusDate).getHours() + 47)).toISOString().replace('T', ' ').substr(0, 23),
        startDataTimeHistorical: startDataTimeHistorical,
        endDateTimeHistorical: endDateTimeHistorical,
        limit: 0,
        history: getHistoricalofCondition
      };


      if (this.targetActiveAlarm.type === "0") {
        chartVariableDisplayData.upperLimit = this.targetActiveAlarm.upperLimit;
        chartVariableDisplayData.lowerLimit = this.targetActiveAlarm.lowerLimit;
        chartVariableDisplayData.hasUpperLimit = this.targetActiveAlarm.hasUpperLimit;
        chartVariableDisplayData.hasLowerLimit = this.targetActiveAlarm.hasLowerLimit;
      } else if (this.targetActiveAlarm.type === "1") {
        chartVariableDisplayData.isActive = this.targetActiveAlarm.isActive;
      }
      this.activeAlarmLineChartOptions = await this.displayVariablesChartOptions(chartVariableDisplayData);
      this.historicActiveAlarmlineChartOptions = await this.displayHistoricChartOptions(chartVariableDisplayData);

    },
    async onDetailAlarm(alarmId) {
      const copyTargetAlarm = JSON.parse(JSON.stringify(this.targetAlarm));

      this.targetAlarm = {};

      this.targetAlarmId = alarmId;
      const newTargetAlarm = this.alarmsList.find((item) => item.id === this.targetAlarmId);

      this.targetAlarm = { ...newTargetAlarm };

      this.targetAlarm.active = false;
      const filteredIncidence = [...this.incidence].filter((item) => item.id === this.targetAlarm.incidenceType);
      if (filteredIncidence.length > 0) {
        this.targetAlarm.incidenceType = filteredIncidence[0].label;
      }
      this.targetAlarm.startDateTime = copyTargetAlarm.startDateTime;
      this.targetAlarm.endDateTime = copyTargetAlarm.endDateTime;
      this.searchSelectedFilter()
    },
    async searchSelectedFilter() {
      const startDateTime = new Date(this.targetAlarm.startDateTime);
      const endDateTime = new Date(this.targetAlarm.endDateTime);
      let startDataTimeHistorical, endDateTimeHistorical;
      if (!isNaN(startDateTime) && !isNaN(endDateTime)) {
        startDataTimeHistorical = new Date(startDateTime.setHours(startDateTime.getHours()))
          .toISOString().replace('T', ' ').substr(0, 23);
        endDateTimeHistorical = new Date(endDateTime.setHours(endDateTime.getHours()))
          .toISOString().replace('T', ' ').substr(0, 23);
      } else {
        //console.error('Invalid date detected:', { startDateTime, endDateTime });
        return;
      }
      const dataforHistorical = {
        id: this.targetAlarm.id,
        startDataTimeHistorical: startDataTimeHistorical,
        endDateTimeHistorical: endDateTimeHistorical
      };

      try {
        const getHistoricalofCondition = await this.getHistoricalofCondition(dataforHistorical);
        this.targetAlarm.historicIncidences = getHistoricalofCondition
          .filter(item => item[2].length > 0)
          .map(item => [item[0], item[2]]);
        const idDCL = this.assetsList.find((item) => item.label === this.selectedAsset);
        if (!idDCL) {
          //console.error('Asset not found with label:', this.selectedAsset);
          return;
        }
        let chartVariableDisplayData = {
          variableLabel: this.targetAlarm.variableLabel,
          variableType: this.targetAlarm.type === "0" ? "1" : "0", // Adjust type cuando se implemente dinamicas
          status: this.targetAlarm.status,
          statusDate: this.targetAlarm.statusDate,
          id: idDCL.id,
          startDateTime: startDataTimeHistorical,
          endDateTime: endDateTimeHistorical,
          limit: 0,
          history: getHistoricalofCondition,
          active: false
        };
        if (this.targetAlarm.type === "0") {
          chartVariableDisplayData.upperLimit = this.targetAlarm.upperLimit;
          chartVariableDisplayData.lowerLimit = this.targetAlarm.lowerLimit;
          chartVariableDisplayData.hasUpperLimit = this.targetAlarm.hasUpperLimit;
          chartVariableDisplayData.hasLowerLimit = this.targetAlarm.hasLowerLimit;
        } else if (this.targetAlarm.type === "1") {
          chartVariableDisplayData.isActive = this.targetAlarm.isActive;
        }
        this.alarmLineChartOptions = await this.displayVariablesChartOptions(chartVariableDisplayData);
        this.historicalarmlineChartOptions = await this.displayHistoricChartOptions(chartVariableDisplayData);
      } catch (error) {
        console.error('Error occurred during data retrieval or chart options setup:', error);
      }
    },
    async onCurrentCompanyChanged(event) {
      let value = event.target.value;
      this.$router.replace({ params: { currentCompanyNifCif: value } })
      this.$emit('setCurrentCompany', value);
      this.selectedCompany = value;
      this.incidenceList = {},
        this.targetActiveAlarmId = null
      this.selectedAsset = null
      this.alarmsList = {}
      this.incidence = {},
        this.activeAlarmsList = {}
      this.preActive = {}
      this.postActive = {}
      this.targetActiveAlarm = ""
      this.targetAlarm = ""
      this.clearTables()
      this.displayAlarmsDataTable()
      this.displayActiveAlarmsDataTable()
      await this.getAssets();
    },
    async onAssetSelected(event) {
      this.targetActiveAlarmId = null
      this.alarmsList = {}
      this.activeAlarmsList = {}
      this.preActive = {}
      this.postActive = {}
      this.targetActiveAlarm = ""
      this.targetAlarm = ""
      this.dcl = '';
      this.clearTables()
      this.displayAlarmsDataTable()
      this.displayActiveAlarmsDataTable()
      let value = event.target.value;
      if (value && this.assetsList.length > 0) {
        const asset = this.assetsList.filter((item) => item.label === value);
        if (asset.length > 0) {
          this.dcl = asset;
          await this.getAlarmsbyDcl(asset)
        }
      }
    },
    clearTables() {
      let data = {
        toolbox: {
          feature: {
            dataView: {
              readOnly: true
            },
            dataZoom: {
              show: true,
              yAxisIndex: null
            },
            magicType: {
              type: ['line', 'bar']
            },
            saveAsImage: {
              pixelRatio: 2
            }
          }
        }
      }
      this.alarmLineChartOptions = data;
      this.historicalarmlineChartOptions = data;
      this.activeAlarmLineChartOptions = data;
      this.historicActiveAlarmlineChartOptions = data;
    },
    async getHistoricalofCondition(data) {
      try {
        let response = await api.getHistoricalofCondition(data);
        if (response["status-code"] === "200") {
          return api.parseConditionHistoryFromResponse(response)

        }
      } catch (error) {
        //console.error("Error fetching historical:", error);
      }

    },
    //GET
    async getAlarmsbyDcl(selectedDcl) {
  this.activeAlarmsList = {}; 
  let data = {
    idDcl: selectedDcl[0].id ? selectedDcl[0].id : selectedDcl
  };

  try {
    
    let response = await api.getConditionsByDcl(data);    
    this.alarmsList = [];
    if (response["status-code"] === "200") {
      this.alarmsList = api.parseAlarmListFromResponse(response) || [];  
      }

    if (this.$route.params.currentModule === "smartLockers" || this.$route.params.currentModule === 'fabric' ) {
      let machineData = {
        machineId: selectedDcl[0].id ? selectedDcl[0].id : selectedDcl
      };

      
      let bundleResponse = await api.getBundleListByMachine(machineData);

      if (bundleResponse["status-code"] === "200") {
        const parsedBundle = api.parseBundlesFromResponse(bundleResponse);

        // Crear un array de promesas para obtener las condiciones de cada conjunto
        const bundlePromises = parsedBundle.map(async (bundle) => {
          let bundleConditionData = {
            idDcl: bundle.id
          };
         
          let bundleConditionResponse = await api.getConditionsByDcl(bundleConditionData);

          if (bundleConditionResponse["status-code"] === "200") {
            let bundleConditions = api.parseAlarmListFromResponse(bundleConditionResponse) || [];
           
            bundleConditions.forEach((condition) => {
              condition.label = `${bundle.label}: ${condition.label}`;
              condition.dcl = bundle.id
            });

            return bundleConditions; 
          }
          return []; 
        });       
        const bundleResults = await Promise.all(bundlePromises);        
        this.alarmsList = [...this.alarmsList, ...bundleResults.flat()];
      }
    }

    
    this.activeAlarmsList = [...this.alarmsList].filter((item) => item.status === "2" && item.isAlarm === "true");
    this.preActive = [...this.alarmsList].filter((item) => item.status === "1");
    this.postActive = [...this.alarmsList].filter((item) => item.status === "3");

    
    const incidenceData = {
      nifCif: this.selectedCompany ? this.selectedCompany : this.currentCompany.nifCif
    };

    let incidenceResponse = await api.getIncidencesByCompany(incidenceData);
    this.incidence = api.parseIncidenceListFromResponse(incidenceResponse);

    
    this.displayActiveAlarmsDataTable();
    this.displayAlarmsDataTable();
  } catch (error) {
    console.warn(error.message); 
  }
},
    async getMachine(id) {
      try {
        let response = await api.getLockerData(id);

        return api.parseMachineFromResponse(response)

      } catch (error) {
        //console.error(error)
      }

    },
    async getAssets() {
      this.assetsList = [];
      let response;
      const data = {
        nifCif: this.selectedCompany ? this.selectedCompany : this.currentCompany.nifCif
      };

      const moduleType = this.captureModuleFromUrl();
      try {
        switch (moduleType) {
          case 2:
            response = await api.getMachineListByCompany(data);
            if (response["status-code"] === "200") {
              this.assetsList = api.parseMachinesFromResponse(response);
            }
            break;
          case 3:
            response = await api.getDeviceListByCompany(data);
            if (response["status-code"] === "200") {
              this.assetsList = api.parseDevicesFromResponse(response)
            }
            break;
          case 7:
            response = await api.getStockTypeList(data);

            break;
          default:
          //console.warn("Unknown module type:", moduleType);

        }
      } catch (error) {
        //console.error("Error fetching assets:", error);

      }
    },
    captureModuleFromUrl() {
      try {
        const url = new URL(window.location.href);
        const pathParts = url.pathname.split('/');

        switch (true) {
          case pathParts[3].includes("smartLockers"):
            return 2;
          case pathParts[3].includes("devices"):
            return 3;
          case pathParts[3].includes("fabric"):
            return 2;
          case pathParts[3].includes("storage"):
            return 7;
          default:
            return null;
        }
      } catch (error) {
        //console.error("Error parsing URL:", error);
        return null;
      }
    },
    detectBrowser() {
      const aKeys = ["MSIE", "Firefox", "Safari", "Chrome", "Opera"];
      const sUsrAg = navigator.userAgent;
      let nIdx = aKeys.length - 1;
      for (; nIdx > -1 && sUsrAg.indexOf(aKeys[nIdx]) === -1; nIdx--);

      this.firefox = nIdx === 1 || nIdx === 2 ? true : false;

    },
    formatDateTime(dateTime) {

      return api.parseDateUserTimezone(dateTime, this.session.user, this.$dayjs);
    },
    //SET

    async setChangeIsMuted() {
      let idCondition = event.target.getAttribute('data-id');
      let data = {
        id: idCondition
      }
      try {
        let response = api.setChangeIsMuted(data);
        if (response["status-code"] === "200") {
          await this.getAlarmsbyDcl(this.dcl)
          this.displayActiveAlarmsDataTable()
        }
      } catch (error) {
        //console.error(error)
      }
    },
    // BUTTONS
    setButtonFunctions() {
      setTimeout(() => {
        $(".btnDetailAlarm").get().forEach(btn => {
          btn.addEventListener('click', (event) => {
            const radioValue = event.target.value;
            this.onDetailActiveAlarm(radioValue);
          });
        });
        $(".btnDetailAlarmFromList").get().forEach(btn => {
          btn.addEventListener('click', (event) => {
            const radioValue = event.target.value;
            this.onDetailAlarm(radioValue)
          }
          );
        });
        $(".btnChangeIsMuted").get().forEach(btn => {
          btn.addEventListener('click', this.setChangeIsMuted);
        });
        $(".btnCopyId").get().forEach(btn => {
          btn.addEventListener('click', this.onCopyId);
        });
        $(".btnEditCondition").get().forEach(btn => {
          btn.addEventListener('click', this.onEditCondition);
        });
        $(".btnDeleteCondition").get().forEach(btn => {
          btn.addEventListener('click', this.onDeleteCondition);
        });
      }, 300);
    }


  }, mounted() {
    $("#ActiveAlarmsDataTable").DataTable(
      {
        pagingType: 'full_numbers',
        pageLength: 10,
        processing: true,
        dom: 'Bfrtip',
        buttons: [
          { "extend": 'colvis', "className": 'btn' },
          { "extend": 'copy', "className": 'btn' },
          {
            "extend": 'csv',
            "className": 'btn',
            "action": (e, dt) => {
              this.exportCSVWithDialog(dt);
            }
          },
          { "extend": 'print', "className": 'btn me-0' },
        ],
        columns: this.activeAlarmColumns,
        select: this.dataTableOptions.select,
        language: this.dataTableOptions.language[this.session.user.language],
        //stateSave: this.dataTableOptions.stateSave,
        order: [[2, 'desc']]
      }
    );
    $("#AlarmsDataTable").DataTable({
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      dom: 'Bfrtip',
      buttons: [
        { extend: 'colvis', className: 'btn' },
        { extend: 'copy', className: 'btn' },
        {
          extend: 'csv',
          className: 'btn',
          action: (e, dt) => {
            this.exportCSVWithDialog(dt);
          }
        },
        { extend: 'print', className: 'btn me-0' },
      ],
      columns: this.alarmColumns,
      select: this.dataTableOptions.select,
      language: this.dataTableOptions.language[this.session.user.language],
      order: [[2, 'desc']]
    });

    $(".dataTables_filter").get().forEach((filter) => { filter.getElementsByTagName('input')[0].addEventListener('blur', this.setButtonFunctions) });

  },
  async created() {
    this.getAssets()
    this.detectBrowser()
  },
}
</script>